import { VisibilityOff, Visibility } from "@mui/icons-material";
import {
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  TextField,
  Stack,
  FormControl,
} from "@mui/material";
import { useState } from "react";
import { BaseDialog } from "../common/BaseDialog";
import { ModalFormProps } from "../common/UserMenu";
import { createUser } from "datasheets/model/core/User";

export default function CreateUserDialog({
  modalIsOpen,
  setModalIsOpen,
  onComplete,
}: ModalFormProps & { onComplete: () => void }) {
  let [username, setUsername] = useState("");
  let [name, setName] = useState("");
  let [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <BaseDialog
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      dialogTitle="Create User"
      resetFormValues={() => {
        setPassword("");
        setUsername("");
        setName("");
        setShowPassword(false);
      }}
      onSubmit={() => createUser(username, name, password).then(onComplete)}
    >
      <Stack spacing={2}>
        <FormControl>
          <TextField
            id="username"
            label="Username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </FormControl>
        <FormControl>
          <TextField
            id="name"
            label="Name"
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </FormControl>
        <FormControl>
          <InputLabel htmlFor="password">Current Password</InputLabel>
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            id="password"
            label="Password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((show) => !show)}
                  //onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Stack>
    </BaseDialog>
  );
}
